import * as MicroStacks from '@micro-stacks/react';
import { StacksNetwork } from '@stacks/network';
import { StacksNetworks } from '@stacks/network/src/network';

import { NETWORK } from '../constants/base';
import { getStacksNetwork } from '../utils';

// TODO_R: [RONAH] [RTS]
const useNetwork = (): [NETWORK, StacksNetwork, (n: NETWORK) => void, typeof StacksNetworks] => {
  const { setNetwork, isMainnet } = MicroStacks.useNetwork();
  const network = isMainnet ? 'mainnet' : 'testnet';

  const stacksNetwork = getStacksNetwork(network);

  const networkName = process.env.REACT_APP_DEVNET === 'true' ? 'devnet' : network;
  // TODO_R: при фиксе [RTS] нужно использовать вот этот тип для networkName, чтобы избавиться от 'as any'
  // const networkName: Exclude<(typeof StacksNetworks)[number], 'mocknet'> =
  //   process.env.REACT_APP_DEVNET === 'true' ? 'devnet' : network;

  return [network, stacksNetwork, setNetwork, networkName as any];
};

export default useNetwork;
